import {
  useCart,
  useCartAddDiscount,
  useCartRemoveDiscount,
} from '@backpackjs/storefront';
import { useEffect, useState } from 'react';
import { Svg } from '../Svg';

export function CartDiscount() {
  const [discountCode, setDiscountCode] = useState('');
  const [applied, setApplied] = useState(false);
  const [recentlyApplied, setRecentlyApplied] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(false);

  const { cartAddDiscount, ...addDiscountStatus } = useCartAddDiscount();
  const { cartRemoveDiscount, ...removeDiscountStatus } =
    useCartRemoveDiscount();

  const handleRemoveDiscount = async () => {
    await cartRemoveDiscount();
    setApplied(false);
    setDiscountCode('');
  };

  const handleApplyDiscount = async () => {
    setError(false);
    const cartAddDiscountRS = await cartAddDiscount({
      discountCode,
    });

    if (
      cartAddDiscountRS?.discountCodes?.length &&
      cartAddDiscountRS?.discountCodes[0]?.code === discountCode &&
      cartAddDiscountRS?.discountCodes[0]?.applicable === true
    ) {
      setApplied(true);
      setRecentlyApplied(true);
      setTimeout(() => {
        setRecentlyApplied(false);
      }, 3000);
    } else {
      await handleRemoveDiscount();
      setError(true);
    }
  };

  const handleSubmit = async () => {
    if (applied) {
      await handleRemoveDiscount();
    } else {
      await handleApplyDiscount();
    }
  };

  const cart = useCart();

  useEffect(() => {
    if (
      cart?.discountCodes.length &&
      cart?.discountCodes[0].applicable === true
    ) {
      setApplied(true);
      setDiscountCode(cart?.discountCodes[0].code);

      if (discountCode === cart?.discountCodes[0].code) {
        setDiscountCode(cart?.discountCodes[0].code);
      }
    }
  }, [cart, discountCode]);

  return (
    <div className="discount-code-wrapper bg-[#ecf7ff] px-[18px] py-3">
      <button
        aria-label={`${isOpen ? 'Close' : 'Open'} accordion for discount code}`}
        className="flex w-full items-center justify-between gap-x-4 text-left"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <p className="text-xs font-normal tracking-[-0.01em]">Discount Code</p>
        {isOpen ? (
          <Svg
            className="w-4 text-current"
            src="/svgs/minus.svg#minus"
            title="Minus"
            viewBox="0 0 24 24"
          />
        ) : (
          <Svg
            className="w-4 text-current"
            src="/svgs/plus.svg#plus"
            title="Plus"
            viewBox="0 0 24 24"
          />
        )}
      </button>

      <div
        className={`pb-2 pt-4 lg:max-w-[410px] ${isOpen ? 'block' : 'hidden'}`}
      >
        <div className="input-group relative">
          <input
            aria-label="Discount Code"
            id="discount-code-input"
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? 'discount-code-error' : undefined}
            className={`w-full min-w-0 flex-1 border border-primary px-4 py-2 text-base outline-none lg:h-[40px] ${
              applied ? 'text-mediumGray' : ''
            }`}
            placeholder="Discount Code"
            onChange={({ target }) => setDiscountCode(target.value)}
            value={discountCode}
            readOnly={applied}
          />
          <button
            type="submit"
            disabled={!discountCode.length || addDiscountStatus?.loading}
            className={`absolute right-[3px] top-0 flex h-[40px] cursor-pointer items-center px-[18px] text-xs uppercase ${
              applied ? 'text-[var(--success)]' : 'text-[var(--secondary)]'
            }`}
            onClick={() => handleSubmit()}
          >
            <span>
              {/* eslint-disable-next-line no-nested-ternary */}
              {recentlyApplied ? 'Applied!' : applied ? 'Remove' : 'Apply'}
            </span>
            {recentlyApplied && (
              <Svg
                className="ml-2 w-[14px] text-[var(--success)]"
                src="/svgs/checkmark-with-circle-filled.svg#checkmark-with-circle-filled"
                title="Discount Code Applied"
                viewBox="0 0 14 14"
              />
            )}
          </button>

          {error && (
            <div
              id="discount-code-error"
              className="py-3 text-xs text-error"
              aria-live="polite"
              role="alert"
            >
              Invalid or expired discount code
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
